import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, Paper, Box } from '@mui/material';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ 
  rows = 5, 
  columns = 4,
  showHeader = true 
}) => {
  return (
    <TableContainer component={Paper} sx={{ boxShadow: 0, border: '1px solid', borderColor: 'divider' }}>
      <Table>
        {showHeader && (
          <TableHead>
            <TableRow sx={{ backgroundColor: 'grey.50' }}>
              {Array.from({ length: columns }).map((_, index) => (
                <TableCell key={`header-${index}`} sx={{ py: 2.5 }}>
                  <Skeleton 
                    variant="text" 
                    width={index === 0 ? "50%" : "70%"} 
                    height={24}
                    sx={{ borderRadius: 1 }}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow 
              key={`row-${rowIndex}`} 
              sx={{ 
                '&:not(:last-child)': { 
                  borderBottom: '1px solid',
                  borderColor: 'divider' 
                }
              }}
            >
              {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell key={`cell-${rowIndex}-${colIndex}`} sx={{ py: 2.5 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Skeleton 
                      variant="text" 
                      width={colIndex === 0 ? "60%" : colIndex === columns - 1 ? "40%" : "80%"} 
                      height={20}
                      sx={{ borderRadius: 0.5 }}
                    />
                    {colIndex === 1 && (
                      <Skeleton 
                        variant="text" 
                        width="50%" 
                        height={18}
                        sx={{ borderRadius: 0.5 }}
                      />
                    )}
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSkeleton;